// removed by extract-text-webpack-plugin
module.exports = {"directionButtons":"_2CIj-nhgiT-kqprvxoGsiD","checkbox":"_1YGFIRAjEBh4lWpa3V1clJ","east":"_3Mcs1S9aDDmbi_cuHH2sl9","west":"_7kGZnEetvJlv9jOYrn2Q4","north":"_23Akbz26qmgLnCaiY4ZTQN","south":"_3aL40eWIfhDoD3TXFvxrp6","directionIcon":"_12gN1WBw6xY7KwbpG1YQYC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMWindDirection/OMWindDirection.scss
// module id = 1684
// module chunks = 0